var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"icon"},[_vm._v("(´･ω･)ﾉ(._.`)")]),_c('div',[_vm._v("我怀疑你在乱访问页面呢")]),_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.goToHome),expression:"goToHome",arg:"tap"}],staticClass:"back-home"},[_vm._v("回到首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }